import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { VIOLATIONS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer, createOperationStateReducer,
} from '../../utils/getCrudConfig';
import {
  EXPORT_WORK_CONTROL,
  LOAD_CONTROL_WORK_VIOLATIONS_BY_ID,
  LOAD_CONTROL_WORK_VIOLATIONS_LIST, LOAD_VIOLATIONS_BY_ID, LOAD_VIOLATIONS_LIST,
} from './actions';

const initialState = {
  violationList: [],
  violationListMeta: {},
  loadingViolationList: false,
  loadingCurrentViolation: false,
  currentViolation: {},
  violationControlWorkList: [],
  violationControlWorkListMeta: {},
  loadingViolationControlWorkList: false,
  loadingCurrentViolationControlWork: false,
  currentViolationControlWork: {},
  loadingExportWorkControl: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(VIOLATIONS_MODULE + LOAD_VIOLATIONS_LIST, 'violationList', 'loadingViolationList'),
  ...createLoadParameterReducer(VIOLATIONS_MODULE + LOAD_VIOLATIONS_BY_ID, 'currentViolation', 'loadingCurrentViolation'),
  ...createLoadListReducerWithBegin(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_LIST, 'violationControlWorkList', 'loadingViolationControlWorkList'),
  ...createLoadParameterReducer(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_BY_ID, 'currentViolationControlWork', 'loadingCurrentViolationControlWork'),
  ...createOperationStateReducer(VIOLATIONS_MODULE + EXPORT_WORK_CONTROL, 'loadingExportWorkControl'),
}, initialState);

export default reducer;

export const getViolationData = createSelector(
  [state => state[VIOLATIONS_MODULE]],
  state => {
    const {
      violationList,
      loadingViolationList,
      violationListMeta,
      loadingCurrentViolation,
      currentViolation,
      violationControlWorkList,
      violationControlWorkListMeta,
      loadingViolationControlWorkList,
      loadingCurrentViolationControlWork,
      currentViolationControlWork,
      loadingExportWorkControl,
    } = state;

    return {
      violationList,
      loadingViolationList,
      violationListMeta,
      loadingCurrentViolation,
      currentViolation,
      violationControlWorkList,
      violationControlWorkListMeta,
      loadingViolationControlWorkList,
      loadingCurrentViolationControlWork,
      currentViolationControlWork,
      loadingExportWorkControl,
    };
  },
);
